import { createApp } from 'vue';
import './styles/styles.scss';
import { applyPolyfills, defineCustomElements } from '@telekom/scale-components/loader';
import '@telekom/scale-components/dist/scale-components/scale-components.css';
import { OuterClick } from './directives/outerClick';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import './common/http/interceptors';
import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import VueMatomo from 'vue-matomo';

// fix default icon paths (Leaflet 1.9.x)
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// eslint-disable-next-line @typescript-eslint/no-floating-promises
applyPolyfills().then(() => {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  defineCustomElements(window);
});

const app = createApp(App);

app.directive('outer-click', OuterClick);

app.use(VueMatomo, {
  host: import.meta.env.VITE_APP_MATOMO_URL as string,
  siteId: Number(import.meta.env.VITE_APP_MATOMO_SITE_ID),
  router,
  requireConsent: true,
  trackInitialView: true,
  enableLinkTracking: true,
});

app.use(router);
app.use(i18n);
app.use(store);
app.mount('#app');

export default app;
